import * as React from "react"
import {Box} from "@mui/material"
import { AmchartSeeker, ModalSeeker } from "@ui-seeker/core"

import { useShareOfSearchKPIEvolutionData } from "./@hooks";
import ShareOfSearchKPIEvolutionChartToolbar from "./toolbar";


export default function ShareOfSearchKPIEvolutionChart() {

    const { isLoadingDataEvolution, dataEvolution, dataEvolutionKeys, resetEvolutionData, keywordID, textInfo, dateRange, onChange } = useShareOfSearchKPIEvolutionData()

    if (!dataEvolution?.length || isLoadingDataEvolution) return <></>
    
    return <ModalSeeker 
        hideActions 
        id="evolution-chart"
        isOpen={!!dataEvolution?.length} 
        title={`Share Of Search KPI Evolution ${textInfo} `} 
        controller={() => resetEvolutionData()}
        containerProps={{
            maxWidth:"xl"
        }}
    >
        <AmchartSeeker
            data={dataEvolution}
            title={<Box id="evolution-chart"></Box>}
            pdfProps={{
                titlePDF:`Share Of Search KPI Evolution ${textInfo} `
            }}
            series={dataEvolutionKeys.map(key => ({
                name: key, yField: key,
                xField: "date",
                connect: true,
            }))}
            chartProps={{
                numberFormat: `#,###.##'%'`,
                dateFormatReceived: 'yyyyMMdd',
                xAxis: {
                    categoryField: 'date',
                    isDateAxis: true,
                    dateFormat: 'dd MMM yyyy',
                    baseInterval: {
                        timeUnit: 'day',
                        count: 1
                    }
                },
                yAxis: {
                    numberFormat: "#'%'"
                }
            }}
            cardProps={{ actions: <ShareOfSearchKPIEvolutionChartToolbar keywordID={keywordID} dateRange={dateRange} onChange={onChange} /> }}
            sx={{ height: 500 }}
        />
    </ModalSeeker>
}

